//
// Module for the Account Transaction adjustment's page.
//
rs.module("content/participant/member/accounttransactions/adjustment",

    [/* Dependencies */],

    function () {

        function initialize(jsSelectors, salaryGrid, contributionGrid) {

            // Unpack jsSelector(s)
            var criteria = $.js(jsSelectors.criteria);

            var addSalaryButton = criteria.js(jsSelectors.addSalaryButton);
            var addContributionButton = criteria.js(jsSelectors.addContributionButton);

            // Handle the add link button for the salary grid
            addSalaryButton.click(function () {
                salaryGrid.addRow();
            });

            // Handle the add link button for the contribution grid
            addContributionButton.click(function () {
                contributionGrid.addRow();
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);